import type { ReactNode } from 'react';
import React, { useMemo } from 'react';
import { url as urlUtils } from '@clubmed/utils';
import { IntersectionObserver } from 'Components/frameworks/intersection-observer/IntersectionObserver';
type Props = {
  children?: ReactNode;
  className?: string;
  name: string;
  index?: number;
  onSectionIntersectViewport: (arg0: any) => any;
};

function SectionComponent({
  children,
  className,
  name = '',
  index,
  onSectionIntersectViewport,
}: Props) {
  const intersectionObserverThreshold = useMemo(() => {
    const thresholds: Array<number> = [];
    for (let i = 0; i <= 1.0; i += 0.01) {
      thresholds.push(Math.round(i * 100) / 100);
    }
    return thresholds;
  }, []);

  const anchor = name ? urlUtils.normalizeSlug(name) : null;

  return (
    <IntersectionObserver
      onChange={onSectionIntersectViewport}
      threshold={intersectionObserverThreshold}
    >
      <section
        className={className}
        data-cs-override-id="Section"
        data-index={index}
        data-testid="section"
        id={anchor || null}
      >
        {children}
      </section>
    </IntersectionObserver>
  );
}

export const Section = React.memo(SectionComponent);
